/**
 * Display email for OTP / profile UI. Prefer `user_emails` (`emails[]`) from the API (DHS-2395).
 */
export type UserEmailRow = {
  id?: string
  email?: string
  is_primary?: boolean
  is_active?: boolean
}

export type UserWithEmailShape = {
  email?: string | null
  emails?: UserEmailRow[] | null
}

export function getUserDisplayEmail(user: UserWithEmailShape | null | undefined): string {
  if (!user) {
    return ''
  }
  const list = user.emails
  if (list && list.length > 0) {
    const primary = list.find((e) => e.is_primary)
    const pick = primary || list[0]
    if (pick?.email) {
      return pick.email
    }
  }
  return user.email ?? ''
}
